import { call, put, take, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { api } from 'services';
import { notificationContainer } from 'utils/notificationContainer';
import axios from 'axios';
import fileDownload from 'js-file-download';
import {
	TVatCorrectionsRequestPayload,
	TVatCorrectionsResponsePayload,
	TCurrenciesResponsePayload,
	TSystemTimeResponsePayload,
	TLoadEUCountriesResponsePayload,
	TExchangeRateRequestPayload,
	TExchangeRateResponsePayload,
	TVatCorrectionsSubmitRequestPayload,
	TGbpExchangeRateResponsePayload,
	TVatCorrectionsDownloadRequest,
	TVatCorrectionsDownloadResponse,
	TOrderAvailableCorrectionAmountRequest,
	TOrderAvailableCorrectionAmountResponsePayload,
} from './types';
import {
	getVatCorrectionsSuccess,
	getVatCorrectionsRequest,
	getSystemTimeRequest,
	getSystemTimeSuccess,
	getCurrenciesRequest,
	getCurrenciesSuccess,
	getEUCountriesRequest,
	getEUCountriesSuccess,
	getExchangeRateRequest,
	getExchangeRateSuccess,
	getGbpExchangeRateRequest,
	getGbpExchangeRateSuccess,
	vatCorrectionSubmitRequest,
	vatCorrectionSubmitSuccess,
	vatCorrectionSubmitError,
	vatCorrectionDownloadRequest,
	vatCorrectionDownloadSuccess,
	getOrderAvailableCorrectionAmountRequest,
	getOrderAvailableCorrectionAmountSuccess,
	setOrderAvailableCorrectionAmountError,
} from './reducer';
import { refreshTokenByTimeOutRequest, refreshTokenByTimeOutSuccess } from '../auth/reducer';

export function* getVatCorrectionsWorker(action: PayloadAction<TVatCorrectionsRequestPayload>) {
	const { payload } = action;

	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TVatCorrectionsResponsePayload = yield call(
			api.vatCorrections.getVatCorrections,
			payload,
		);

		yield put(getVatCorrectionsSuccess(response));
	} catch (error) {
		// notificationContainer('Error', error.message);
	}
}

export function* getSystemTimeWorker() {
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TSystemTimeResponsePayload = yield call(api.vatCorrections.getSystemTime);

		yield put(getSystemTimeSuccess(response));
	} catch (error) {
		// notificationContainer('Error', error.message);
	}
}

export function* getCurrenciesWorker() {
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TCurrenciesResponsePayload = yield call(api.vatCorrections.getCurrencies);

		yield put(getCurrenciesSuccess(response));
	} catch (error) {
		// notificationContainer('Error', error.message);
	}
}

export function* getEUCountriesWorker() {
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TLoadEUCountriesResponsePayload = yield call(api.vatCorrections.getEUCountries);

		yield put(getEUCountriesSuccess(response));
	} catch (error) {
		// notificationContainer('Error', error.message);
	}
}

export function* getExchangeRateWorker(action: PayloadAction<TExchangeRateRequestPayload>) {
	const { payload } = action;

	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TExchangeRateResponsePayload = yield call(
			api.vatCorrections.getExchangeRate,
			payload,
		);

		yield put(getExchangeRateSuccess(response));
	} catch (error) {
		// notificationContainer('Error', errorMessage);
	}
}

export function* getGbpExchangeRateWorker(action: PayloadAction<TExchangeRateRequestPayload>) {
	const { payload } = action;

	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TGbpExchangeRateResponsePayload = yield call(
			api.vatCorrections.getGbpExchangeRate,
			payload,
		);

		yield put(getGbpExchangeRateSuccess(response));
	} catch (error) {
		// notificationContainer('Error', errorMessage);
	}
}

export function* vatCorrectionSubmitWorker(
	action: PayloadAction<TVatCorrectionsSubmitRequestPayload>,
) {
	const { payload } = action;

	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		yield call(api.vatCorrections.vatCorrectionSubmit, payload);

		yield put(vatCorrectionSubmitSuccess());
		notificationContainer('VAT correction submitted successfully', 'success');
		setTimeout(() => {
			window.location.reload();
		}, 1000);
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
			yield put(vatCorrectionSubmitError(String(error.response?.data.message ?? 'Error')));
		} else {
			notificationContainer('Error', 'error');
			yield put(vatCorrectionSubmitError('Error'));
		}
	}
}

function* vatCorrectionDownloadWorker(action: PayloadAction<TVatCorrectionsDownloadRequest>) {
	const { id, filename } = action.payload;

	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TVatCorrectionsDownloadResponse = yield call(
			api.vatCorrections.vatCorrectionDownload,
			{ id },
		);

		if (response) {
			yield fileDownload(response, filename);
		}
		yield put(vatCorrectionDownloadSuccess());
	} catch (error) {
		if (axios.isAxiosError(error))
			notificationContainer(
				error?.response?.data?.message ?? error.message ?? 'File download error',
				'error',
			);
		yield put(vatCorrectionDownloadSuccess());
	}
}

export function* getOrderAvailableCorrectionAmountWorker(
	action: PayloadAction<TOrderAvailableCorrectionAmountRequest>,
) {
	const { payload } = action;

	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TOrderAvailableCorrectionAmountResponsePayload = yield call(
			api.vatCorrections.getOrderAvailableCorrectionAmount,
			payload,
		);
		yield put(getOrderAvailableCorrectionAmountSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			yield put(
				setOrderAvailableCorrectionAmountError(
					error?.response?.data?.message ?? error?.message ?? 'Corrections amount error',
				),
			);
			// notificationContainer(
			// 	error?.response?.data?.message ?? error?.message ?? 'Corrections amount error',
			// 	'error',
			// );
		}
		// notificationContainer('Error', error.message);
	}
}

export function* vatCorrectionsSaga() {
	yield takeLatest(getVatCorrectionsRequest.type, getVatCorrectionsWorker);
	yield takeLatest(getSystemTimeRequest.type, getSystemTimeWorker);
	yield takeLatest(getCurrenciesRequest.type, getCurrenciesWorker);
	yield takeLatest(getEUCountriesRequest.type, getEUCountriesWorker);
	yield takeLatest(getExchangeRateRequest.type, getExchangeRateWorker);
	yield takeLatest(vatCorrectionSubmitRequest.type, vatCorrectionSubmitWorker);
	yield takeLatest(getGbpExchangeRateRequest.type, getGbpExchangeRateWorker);
	yield takeLatest(vatCorrectionDownloadRequest.type, vatCorrectionDownloadWorker);
	yield takeLatest(
		getOrderAvailableCorrectionAmountRequest.type,
		getOrderAvailableCorrectionAmountWorker,
	);
}
